import PropTypes from "prop-types";
import React from "react";
import { get } from "lodash";
import SelectBase from "../SelectBase";
import Formatter from "../../Table3/CellFormatters/ItemBlock";
import Editor from "../../Editors/ItemBlockEditor";

const ItemBlockSelect = ({
  onChange,
  options,
  limit,
  value,
  rowMetaData,
  column,
  disabled
}) => {
  const type = get(column, "settings.selection_type");
  const editor = (
    <Editor
      column={column}
      onChange={onChange}
      options={options}
      limit={limit}
      value={value}
      disabled={disabled}
      className="styled"
    />
  );

  if (type === "quantity-only-input") {
    return editor;
  }

  // Add dropdown wrapper
  return (
    <SelectBase
      // @NOTE: These props allow SelectBase to save values onClose
      // of the popover instead of on each value change
      saveOnClose
      initialValue={value}
      onClose={onChange}
      //
      formatter={
        get(value, "value.length") ? (
          <Formatter dependentValues={rowMetaData} value={value} />
        ) : null
      }
      editor={editor}
    />
  );
};
ItemBlockSelect.propTypes = {
  value: PropTypes.object,
  rowMetaData: PropTypes.object.isRequired,
  column: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default ItemBlockSelect;
